/** @caution 마플샵 서버에서 정의된 형식을 따릅니다. */
export const ENationCode = {
  En: "en",
  Kr: "kr",
  Jp: "jp",
} as const;

export type ENationCode = typeof ENationCode[keyof typeof ENationCode];
